module.exports = "/images/knoume_bunner_PC.png?a5542d45b13532b5fb9fa16493cdde41";